import { createFileRoute } from '@tanstack/react-router';
import { ytCmsStaticsData } from '../../youtube-cms';

export const Route = createFileRoute('/_private-routes/youtube-cms/revenue/confirmed')({
  staticData: ytCmsStaticsData
});
